import * as React from "react";
import { useState, useEffect } from "react";
import { Button, KIND } from "baseui/button";
import { Input} from "baseui/input";
import { useStyletron, styled } from "baseui";
import { LabelLarge } from "baseui/typography";
import { InputContainer, MainContainer }  from "./LoginStyles";
import { AuthForm, StyledLink } from './AuthForm'; // Import AuthForm

function NewPasswordView(props) {
  const [css, theme] = useStyletron();
    const [code, setCode] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassowrd, setConfirmPassowrd] = useState("");
  const [isLoading, setIsLoading] = useState(props.isLoading);
  const [error, setError] = useState(props.error);


  useEffect(() => {
    setError(props.error);
    setIsLoading(props.isLoading);
  }, [props.error, props.isLoading]);

  const handleSubmitNewPassword = () => {
    if(!code){
        setError("Please enter code")
        return;
    };
    if(!password){
        setError("Please enter password")
        return
    };
    if(!confirmPassowrd){
        setError("Please enter confirm password")
        return
    };
    if(password !== confirmPassowrd){
      setError("Password and Confirm Password should be same")
      return
  };
  props.onSubmitnewPassword(code, password)
}
  return (
    <AuthForm error={error} isLoading={props.isLoading}>
            <div className={css({ marginBottom: theme.sizing.scale600 })}>
              <LabelLarge
                className={css({ marginBottom: theme.sizing.scale300 })}
              >
                Reset Your Password
              </LabelLarge>
              <Input
                type="number"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter Code"
              />
            </div>
            <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="New Password"
                clearable
              />
            </div>            
            <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
                type="password"
                value={confirmPassowrd}
                onChange={(e) => setConfirmPassowrd(e.target.value)}
                placeholder="Confirm Password"
                clearable
              />
            </div>            
            <div className={css({ marginBottom: theme.sizing.scale600 })}>
              <Button
                kind={KIND.primary}
                isLoading={isLoading}
                onClick={()=> handleSubmitNewPassword(password)}
                overrides={{
                  BaseButton: { style: { width: "100%" } },
                }}
              >
                Submit
              </Button>
            </div>
            <div
              className={css({
                display: "flex", // Use flexbox to center the link
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
                marginBottom: theme.sizing.scale600,
              })}
            >
              <StyledLink onClick={props.onResendCode}>
                Resend Code
              </StyledLink>
            </div>
          </AuthForm>

  );
}
export default NewPasswordView;
